module.exports = __webpack_public_path__ + "img/17-3.728230f1.jpg";